import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const ChevronUp = createSvgIcon(React.createElement("polygon", { points: "12,7.1 20.5,15.5 19.1,16.9 12,9.9 4.9,16.9 3.5,15.5" }), 'ChevronUp');
export default ChevronUp;
